import PinnedPanel from './PinnedPanel';
export default PinnedPanel;
